import { Injectable } from "@angular/core";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

@Injectable({ providedIn: "root" })
export class AzureAuthErrorService {
	isRecoverable(error: unknown): boolean {
		return (
			error instanceof InteractionRequiredAuthError ||
			this.matches(error, [
				"aadsts700084",
				"700084",
				"bad_token",
				"invalid_grant",
				"interaction_required",
				"login_required",
				"consent_required",
				"monitor_window_timeout",
				"timed_out",
				"iframe_closed_prematurely",
				"block_iframe_reload",
			])
		);
	}

	isAccountNotFound(error: unknown): boolean {
		return this.matches(error, [
			"aadsts50034",
			"50034",
			"user account does not exist",
			"aadsts50020",
			"50020",
			"does not exist in tenant",
			"account_mismatch",
		]);
	}

	private matches(error: unknown, patterns: string[]): boolean {
		const text = this.getText(error);
		return patterns.some((pattern) => text.includes(pattern));
	}

	private getText(error: unknown): string {
		if (!error) {
			return "";
		}

		const source = error as {
			message?: string;
			errorMessage?: string;
			errorCode?: string;
			subError?: string;
			error?: unknown;
			error_description?: string;
		};

		let serialized = "";
		try {
			serialized = JSON.stringify(error);
		} catch {
			serialized = "";
		}

		return [
			source.message,
			source.errorMessage,
			source.errorCode,
			source.subError,
			source.error,
			source.error_description,
			serialized,
		]
			.filter(Boolean)
			.join(" ")
			.toLowerCase();
	}
}
